import styled from 'styled-components';
import {
  breakpoints,
  colors,
  fonts,
  pxToCssFont,
  pxToRem,
  theme,
  media,
} from '@vfit/shared/themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: inherit;

  @media (min-width: ${breakpoints.tablet}) {
    margin: 0 auto;
  }
`;

export const DetailTitle = styled.div`
  font-family: ${fonts.exbold};
  font-weight: 400;
  color: ${colors.$262626};
  ${pxToCssFont(30, 38)}
  margin-bottom: ${pxToRem(32)};

  @media (min-width: ${breakpoints.tablet}) {
    margin-bottom: ${pxToRem(24)};
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 45)}
    margin-bottom: ${pxToRem(32)};
  }
`;

export const DetailDesc = styled.div`
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  color: ${theme.colors.text.primary};
  font-size: ${theme.typography.fontSize.h6};
  line-height: ${theme.typography.lineHeight.h6};
  margin-bottom: ${theme.spacing.xl};

  ${media.tablet`
        font-size: ${theme.typography.fontSize.body1};
        line-height: ${theme.typography.lineHeight.body1};
        margin-bottom: 60px;
  `}
`;

